import styled from 'styled-components';

export const DelButton = styled.div`
    background-color: var(--primary);
    color: white;
    font-weight: bold;
    padding: 3px 50px;
    border-radius: 15px;
    position: relative;
`;

export const DialogMessage = styled.div`
    text-align: center;
`;
